import Http from './http'
// import Vue from 'vue'
// const instance = new Vue()
import { httpNotification } from '../notification'

export default class BaseServiceHttp {
  uri = ''
  endpoint = ''
  _http
  requests = {
    show: {
      action: 'buscar',
      method: 'get'
    },
    store: {
      action: 'salvar',
      method: 'post'
    },
    update: {
      action: 'atualizar',
      method: 'put'
    },
    delete: {
      action: 'apagar',
      method: 'delete'
    }
  }

  constructor(id = '', resource, relationship = '', baseURL) {
    this.id = id ? `/${id}` : ''
    this.resource = resource
    this.relationship = relationship
    this._http = new Http(baseURL)
    this.generateRelationships()
    this.assignMethodsHTTP()
  }

  http() {
    return this._http
  }

  getURI() {
    this.uri = `${this.resource}${this.id}${this.endpoint}`
    return this.uri
  }

  getRelationship(relation = '', _id = '') {
    _id = _id ? `/${_id}` : ''
    this.endpoint = relation ? `${this.endpoint}/${relation}${_id}` : ''
    return this
  }

  generateRelationships() {
    // eslint-disable-next-line array-callback-return
    Object.keys(this.relationship).map(key => {
      Object.assign(BaseServiceHttp.prototype, {
        [key]: _id => {
          this.getRelationship(this.relationship[key], _id)
          return this
        }
      })
    })
  }

  assignMethods(base, index) {
    return Object.assign(BaseServiceHttp.prototype, {
      [index]: this.generateRequests(base, index)
    })
  }

  // error(verb, msg) {
  //   // instance.$toast.error(msg || `Erro ao ${verb} ${this.resource}`)

  // }

  // success(verb, msg) {
  //   // instance.$toast.success(msg || `Sucesso ao ${verb}`)

  // }

  // checkSetup(setup) {
  //   if (!('useCache' in setup)) setup.useCache = false
  //   return setup
  // }

  hasQueryString(httpMethod, data) {
    if (httpMethod === 'get') return { params: { ...data } }
    return data
  }

  async createMethodHTTP(data, settings, config = {}) {
    data = this.hasQueryString(settings.method, data)
    // console.log(setup)
    // Object.assign(data, this.checkSetup(setup))

    try {
      const res = await this.http()[settings.method](
        this.getURI(),
        data,
        config
      )
      if (config?.notification)
        httpNotification('success', settings.action, config?.message)
      return res
    } catch (err) {
      const validations = err.response?.data?.data

      if (typeof validations === 'string') {
        httpNotification('error', settings.action, validations)
      } else if (validations && typeof validations === 'object') {
        for (const msg in validations) {
          if (typeof validations[msg] === 'string') {
            httpNotification('error', settings.action, validations[msg])
          }
          if (typeof validations[msg] === 'object') {
            validations[msg].forEach(err => {
              httpNotification('error', settings.action, err)
            })
          }
        }
      }

      return err?.response || err
    }
  }

  assignMethodsHTTP() {
    const commomRequests = Object.keys(this.requests)
    commomRequests.map(req => {
      return Object.assign(BaseServiceHttp.prototype, {
        [req]: (base, config, setup) => {
          return this.createMethodHTTP(base, this.requests[req], config, setup)
        }
      })
    })
  }
}
